<template>
  <div class="colorpicker colorpicker-top-left-triangle">
    <div class="colorpicker-triangle-shadow"></div>
    <div class="colorpicker-triangle"></div>

    <div class="colorpicker-body">
      <span
          class="colorpicker-swatch"
          :style="{
            background: color,
            boxShadow: `0 0 4px ${ equal(color) ? color : 'transparent' }`,
          }"
          v-for="(color, index) in defaultColors"
          :key="index"
          @click="handlerClick(color)"
      ></span>
      <span
          class="colorpicker-swatch"
          :style="{
            background: modelValue,
            boxShadow: `0 0 4px ${modelValue}`,
          }"
          v-if="defaultColors.indexOf(modelValue) < 0"
          @click="handlerClick(modelValue)"
      ></span>
      <div class="colorpicker-clear"></div>
    </div>
  </div>
</template>

<script setup lang="js">
const props = defineProps(['modelValue'])
const emit = defineEmits(['update:modelValue', 'click'])

const defaultColors = [
  '#555555', '#FF6900', '#FCB900', '#7BDCB5', '#00D084', '#8ED1FC', '#0693E3', '#ABB8C3', '#EB144C', '#F78DA7', '#9900EF'
]

const equal = color => {
  return color.toLowerCase() === props.modelValue.toLowerCase()
}

const handlerClick = color => {
  emit('update:modelValue', color)
  emit('click', color)
}
</script>

<style lang="scss" scoped>
.colorpicker {
  width: 276px;
  background: #fff;
  border: 0 solid rgba(0, 0, 0, 0.25);
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  position: absolute;

  .colorpicker-triangle {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 9px 10px 9px;
    border-color: transparent transparent #fff transparent;
    position: absolute;
  }

  .colorpicker-triangle-shadow {
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 9px 10px 9px;
    border-color: transparent transparent rgba(0, 0, 0, .1) transparent;
    position: absolute;
  }

  .colorpicker-body {
    padding: 15px 9px 9px 15px;

    .colorpicker-swatch {
      width: 30px;
      height: 30px;
      border-radius: 4px;
      margin: 0 6px 6px 0;
      cursor: pointer;
      // position: relative;
      outline: none;
      float: left;
    }
  }

  .colorpicker-triangle {
    top: -10px;
    left: 12px;
  }

  .colorpicker-triangle-shadow {
    top: -11px;
    left: 12px;
  }

  .colorpicker-clear {
    clear: both;
  }
}
</style>